import { useAppStore } from "@/stores/appStore";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

export const useForceUpdateRedirect = () => {
  const { user, isRedirecting, setIsRedirecting, setIsForceUpdate } =
    useAppStore();
  const router = useRouter();

  useEffect(() => {
    const handleRedirect = async () => {
      if (user) {
        setIsForceUpdate(user.forced_update_redirect);
      }
      if (
        user?.forced_update_redirect &&
        !isRedirecting &&
        router.pathname !== "/forceUpdate"
      ) {
        setIsRedirecting(true);

        try {
          await router.push("/forceUpdate");
        } catch (error) {
          console.error("Failed to redirect:", error);
        }
        setIsRedirecting(false);
      }
    };

    handleRedirect();
  }, [user, isRedirecting, setIsRedirecting, setIsForceUpdate, router]);
};
